import { useCallback, useEffect, useRef, useState } from "react";
import Navbar from "~/components/@core/navbar";
import BusinessRuleComponent from "~/components/pages/businessule";
import ToggleButton from "~/components/pages/supervisor/users/toggle";
import { BusinessRuleStateProvider } from "~/hooks/businessRule/use-businessRule";

import { decodeJWToken } from "~/utils/basic";
import { decryptData } from "~/utils/crypto";
import { SidebarMenuItem } from "../supervisor/side-bar";
import { getBusinessRulesMenuItems } from "~/services/supervisor.services";
import { ISidebarMenuItem } from "~/types/agent-types";
export default function BusinessRulePage() {
  const [userName, setUserName] = useState<string | null>(null);
  const [isExpand, setIsExpand] = useState(false);
  const [sidebarItemsToDisplay, setSidebarItemsToDisplay] = useState<ISidebarMenuItem[]>([]);
  const [businessRuleSidebarItems, setBusinessRuleSidebarItems] = useState<ISidebarMenuItem[]>([]);
  const roleid = localStorage.getItem("roleid");

  // Fetch business rule menu items once on mount
  useEffect(() => {
    async function fetchBusinessRuleMenu() {
      const { data, status } = await getBusinessRulesMenuItems("business_rule_menu_items");
      if (status && data && Array.isArray(data.data?.menu_items)) {
        setBusinessRuleSidebarItems(data.data.menu_items as ISidebarMenuItem[]);
      } else if (status && Array.isArray(data)) {
        setBusinessRuleSidebarItems(data as ISidebarMenuItem[]);
      } else {
        setBusinessRuleSidebarItems([]);
      }
    }
    fetchBusinessRuleMenu();
  }, []);
  // Update sidebar items based on roleid and fetched business rules
  useEffect(() => {
    if (roleid === "16") {
      setSidebarItemsToDisplay(businessRuleSidebarItems);
    } else {
      setSidebarItemsToDisplay([]); // or fallback menu items if needed
    }
  }, [roleid, businessRuleSidebarItems]);
  const sidebarRef = useRef<HTMLDivElement>(null);
  // Handle click outside sidebar to collapse it
  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target as Node)) {
      setIsExpand(false);
    }
  }, []);
  useEffect(() => {
    if (isExpand) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [handleClickOutside, isExpand]);
  useEffect(() => {
    async function fetchUserName() {
      const token = localStorage.getItem("id_token"); // Retrieve the token from local storage
      if (token) {
        const payload = decodeJWToken(decryptData(token));
        setUserName(payload.user_name); // Set the user name from the token
      }
    }

    fetchUserName();
  }, []);
  return (
    <BusinessRuleStateProvider>
      <div className="flex flex-col h-screen overflow-scroll">
        <Navbar userName={userName} />
        <div className="flex flex-grow overflow-scroll">
          <aside className="space-y-2 bg-neutral-100" ref={sidebarRef}>
            <ToggleButton isExpand={isExpand} setIsExpand={setIsExpand} />
            {isExpand && (
              <div className="w-52 border-r h-full">
                <div>
                  <ul className="w-full divide-y flex flex-col">
                    {sidebarItemsToDisplay.map((item, idx) => (
                      <SidebarMenuItem key={idx} item={item} setIsExpand={setIsExpand} />
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </aside>
          <main className="p-4 flex-grow overflow-y-scroll">
            <BusinessRuleComponent />
          </main>
        </div>
      </div>
    </BusinessRuleStateProvider>
  );
}